import { FormControl, FormGroup } from '@angular/forms';
import { StorageType } from 'mbs-ui-shared';
import { S3AuthType } from 'mbs-ui-shared@models/StorageAccount';
export enum AccountType {
  Public = 0,
  Germany = 1,
  China = 2,
  Government = 3,
  AzureStack = 5
}

export enum KeystoneVersion {
  Second = 2,
  Third = 3,
  None = 1
}

export enum TenantIdentifier {
  Name,
  Id
}

export enum DomainIdentifier {
  Name,
  Id
}

export enum ProjectIdentifier {
  Name,
  Id
}

export type AzureCredentialForm = FormGroup<{
  endpoint: FormControl<string>;
  accountName: FormControl<string>;
  accountType: FormControl<AccountType>;
  sharedKey: FormControl<string>;
}>;

export type AzureVMCredentialForm = FormGroup<{
  subscriptionId: FormControl<string>;
  refreshToken: FormControl<string>;
  tenantId: FormControl<string>;
  subscriptionDisplayName: FormControl<string>;
}>;

export type BackBlazeCredentialForm = FormGroup<{
  accountId: FormControl<string>;
  applicationKey: FormControl<string>;
}>;

export type FSCredentialForm = FormGroup<{
  user: FormControl<string>;
  password: FormControl<string>;
}>;

export type GoogleCloudCredentialForm = FormGroup<{
  serviceAccountEmail: FormControl<string>;
  binaryKeyInBase64: FormControl<string>;
  projectId: FormControl<string>;
}>;

export type MinioCredentialForm = FormGroup<{
  useVHostRequestStyle: FormControl<boolean>;
  isSyntheticBackupAllowed: FormControl<boolean>;
  isVersioningEnabled: FormControl<boolean>;
  accessKey: FormControl<string>;
  secretKey: FormControl<string>;
  useNativeMultipartUpload: FormControl<boolean>;
  httpEndpoint: FormControl<string>;
  httpsEndpoint: FormControl<string>;
  ignoreCertificate: FormControl<boolean>;
  keepCredentialsOnEndpoint: FormControl<boolean>;
  isPrivateStorage: FormControl<boolean>;
}>;

export type S3CredentialForm = FormGroup<{
  storageType: FormControl<StorageType>;
  arnRole: FormControl<string>;
  isGov: FormControl<boolean>;
  authType: FormControl<S3AuthType>;
  accessKey: FormControl<string>;
  secretKey: FormControl<string>;
}>;

export type S3CompatibleCredentialForm = FormGroup<{
  useVHostRequestStyle: FormControl<boolean>;
  isSyntheticBackupAllowed: FormControl<boolean>;
  isVersioningEnabled: FormControl<boolean>;
  useSignatureVersion4: FormControl<boolean>;
  accessKey: FormControl<string>;
  secretKey: FormControl<string>;
  useNativeMultipartUpload: FormControl<boolean>;
  httpEndpoint: FormControl<string>;
  httpsEndpoint: FormControl<string>;
  ignoreCertificate: FormControl<boolean>;
  keepCredentialsOnEndpoint: FormControl<boolean>;
  isPrivateStorage: FormControl<boolean>;
}>;

export type WasabiCredentialForm = FormGroup<{
  arnRole: FormControl<string>;
  authType: FormControl<S3AuthType>;
  accessKey: FormControl<string>;
  secretKey: FormControl<string>;
}>;

export type ImpossibleCloudCredentialForm = FormGroup<{
  accessKey: FormControl<string>;
  secretKey: FormControl<string>;
}>;

export type FTPCredentialForm = FormGroup<{
  user: FormControl<string>;
  password: FormControl<string>;
  endpoint: FormControl<string>;
  isPrivateStorage: FormControl<boolean>;
  useSSL: FormControl<boolean>;
  keepAlive: FormControl<boolean>;
  usePassiveMode: FormControl<boolean>;
}>;

export type SFTPCredentialForm = FormGroup<{
  user: FormControl<string>;
  password: FormControl<string>;
  endpoint: FormControl<string>;
  isPrivateStorage: FormControl<boolean>;
  keepAlive: FormControl<boolean>;
}>;

export type ScalityCredentialForm = FormGroup<{
  accessKey: FormControl<string>;
  secretKey: FormControl<string>;
  signatureVersion: FormControl<string>;
  useNativeMultipartUpload: FormControl<boolean>;
  httpEndpoint: FormControl<string>;
  httpsEndpoint: FormControl<string>;
  privateStorage: FormControl<boolean>;
}>;

export type OpenstackCredentialForm = FormGroup<{
  userName: FormControl<string>;
  apiKey: FormControl<string>;
  endpoint: FormControl<string>;
  keystoneVersion: FormControl<KeystoneVersion>;
  tenantIdentifier: FormControl<TenantIdentifier>;
  tenant: FormControl<string>;
  domainIdentifier: FormControl<DomainIdentifier>;
  domain: FormControl<string>;
  projectIdentifier: FormControl<ProjectIdentifier>;
  project: FormControl<string>;
  useScope: FormControl<boolean>;
  useInternalUrls: FormControl<boolean>;
  isPrivateStorage: FormControl<boolean>;
  ignoreCertificates: FormControl<boolean>;
}>;

export type IDriveE2CredentialForm = FormGroup<{
  accessKey: FormControl<string>;
  secretKey: FormControl<string>;
}>;

export type GoogleDriveCredentialForm = FormGroup<{
  email: FormControl<string>;
  refreshToken: FormControl<string>;
}>;

export type CredentialForm =
  | OpenstackCredentialForm
  | ScalityCredentialForm
  | SFTPCredentialForm
  | FTPCredentialForm
  | WasabiCredentialForm
  | AzureCredentialForm
  | AzureVMCredentialForm
  | BackBlazeCredentialForm
  | FSCredentialForm
  | GoogleCloudCredentialForm
  | MinioCredentialForm
  | S3CompatibleCredentialForm
  | S3CredentialForm
  | IDriveE2CredentialForm
  | GoogleDriveCredentialForm
  | ImpossibleCloudCredentialForm;
